module.exports = __webpack_public_path__ + "img/绿城.eb9090cc.png";